// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3reP2","rootCenter":"LoadMoreObserver_rootCenter__jIJ98","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3g4k-"};